import Breadcrumbs from "@/Components/Breadcrumbs";

/**
 * Main layout component
 * @param {Object} props
 * @param {Object} props.children
 *
 * @returns
 */
export default function MainLayout({ children, showBreadcrumbs = true }) {
    const currentYear = new Date().getFullYear();

    return (
        <>
            <header className="border-b">
                <div className="container mx-auto flex items-center justify-center py-4 px-4 md:px-0">
                    <a href="/">
                        <img
                            src="/img/bassa-ai-logo.svg"
                            className="h-10 md:h-14 w-auto"
                            alt=""
                        />
                    </a>
                </div>
            </header>

            {showBreadcrumbs && (
                <div className="container mx-auto py-6">
                    <Breadcrumbs />
                </div>
            )}

            <main>
                <div className="container mx-auto px-4 md:px-0 w-full">
                    {children}
                </div>
            </main>

            <footer className="mt-12 border-t pt-12">
                <div className="container mx-auto flex flex-wrap">
                    <div
                        aria-label="Logo y redes sociales"
                        className="flex w-full flex-col px-4"
                    >
                        <img
                            alt="Logo Bassa"
                            className="h-12 w-auto"
                            src="/img/logo.svg"
                        />
                        <ul className="mt-6 flex w-full justify-center space-x-4 p-0">
                            <li>
                                <a href="https://www.instagram.com/bassa_ec/">
                                    <img
                                        alt=""
                                        src="/img/ig-icon.png"
                                        width="30"
                                    />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.facebook.com/Bassa.ec">
                                    <img
                                        alt=""
                                        src="/img/fb-icon.png"
                                        width="30"
                                    />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.tiktok.com/@bassa_ec">
                                    <img
                                        alt=""
                                        src="/img/titok-icon.png"
                                        width="30"
                                    />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.youtube.com/channel/UC3x0I4msEirhmb0lAfke4qw">
                                    <img
                                        alt=""
                                        src="/img/youtube-icon.png"
                                        width="30"
                                    />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="mt-12 bg-primary-400 py-3 text-center text-white">
                    <span>
                        Copyright Activa {currentYear} All - Rights Reserved
                    </span>
                </div>
            </footer>
        </>
    );
}
